export default __webpack_public_path__ + "static/media/drag_indicator.7bbe84c9.svg";